'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ALL: null,
  SINGLE_COLUMN: null,
  TWO_COLUMN: null,
  THREE_COLUMN: null,
  FOUR_COLUMN: null,
  MULTI_ROW: null
});